<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="ch1"><span class="epub-bi">Chapter I</span></p>
<p class="vh1"><span class="epub-sc">I</span></p>
<p class="v">“This is how, one sunrise, we cut down them canoes.”</p>
<p class="v">Philoctete smiles for the tourists, who try taking</p>
<p class="vsb">his soul with their cameras. “Once wind bring the news</p>
<p class="v">to the <span class="epub-i">laurier-cannelles,</span> their leaves start shaking</p>
<p class="v">the minute the axe of sunlight hit the cedars,</p>
<p class="vsb">because they could see the axes in our own eyes.</p>
<p class="v">Wind lift the ferns. They sound like the sea that feed us</p>
<p class="v">fishermen all our life, and the ferns nodded ‘Yes,</p>
<p class="vsb">the trees have to die.’ So, fists jam in our jacket,</p>
<p class="v">cause the heights was cold and our breath making feathers</p>
<p class="v">like the mist, we pass the rum. When it came back, it</p>
<p class="vsb">give us the spirit to turn into murderers.</p>
<p class="v">I lift up the axe and pray for strength in my hands</p>
<p class="v">to wound the first cedar. Dew was filling my eyes,</p>
<p class="vsb">but I fire one more white rum. Then we advance.”</p>
<p class="v">For some extra silver, under a sea-almond,</p>
<p class="v">he shows them a scar made by a rusted anchor,</p>
<p class="vsb">rolling one trouser-leg up with the rising moan</p>
<p class="v">of a conch. It has puckered like the corolla</p>
<p class="v">of a sea-urchin. He does not explain its cure.</p>
<p class="vsb">“It have some things”—he smiles—“worth more than a dollar.”</p>
<p class="v">He has left it to a garrulous waterfall</p>
<p class="v">to pour out his secret down La Sorcière, since</p>
<p class="vsb">the tall laurels fell, for the ground-dove’s mating call</p>
<p class="v">to pass on its note to the blue, tacit mountains</p>
<p class="v">whose talkative brooks, carrying it to the sea,</p>
<p class="vsb">turn into idle pools where the clear minnows shoot</p>
<p class="v">and an egret stalks the reeds with one rusted cry</p>
<p class="v">as it stabs and stabs the mud with one lifting foot.</p>
<p class="vsb">Then silence is sawn in half by a dragonfly</p>
<p class="v">as eels sign their names along the clear bottom-sand,</p>
<p class="v">when the sunrise brightens the river’s memory</p>
<p class="vsb">and waves of huge ferns are nodding to the sea’s sound.</p>
<p class="v">Although smoke forgets the earth from which it ascends,</p>
<p class="v">and nettles guard the holes where the laurels were killed,</p>
<p class="vsb">an iguana hears the axes, clouding each lens</p>
<p class="v">over its lost name, when the hunched island was called</p>
<p class="v">“Iounalao,” “Where the iguana is found.”</p>
<p class="vsb">But, taking its own time, the iguana will scale</p>
<p class="v">the rigging of vines in a year, its dewlap fanned,</p>
<p class="v">its elbows akimbo, its deliberate tail</p>
<p class="vsb">moving with the island. The slit pods of its eyes</p>
<p class="v">ripened in a pause that lasted for centuries,</p>
<p class="v">that rose with the Aruacs’ smoke till a new race</p>
<p class="vsb">unknown to the lizard stood measuring the trees.</p>
<p class="v">These were their pillars that fell, leaving a blue space</p>
<p class="v">for a single God where the old gods stood before.</p>
<p class="vsb">The first god was a gommier. The generator</p>
<p class="v">began with a whine, and a shark, with sidewise jaw,</p>
<p class="v">sent the chips flying like mackerel over water</p>
<p class="vsb">into trembling weeds. Now they cut off the saw,</p>
<p class="v">still hot and shaking, to examine the wound it</p>
<p class="v">had made. They scraped off its gangrenous moss, then ripped</p>
<p class="vsb">the wound clear of the net of vines that still bound it</p>
<p class="v">to this earth, and nodded. The generator whipped</p>
<p class="v">back to its work, and the chips flew much faster as</p>
<p class="vsb">the shark’s teeth gnawed evenly. They covered their eyes</p>
<p class="v">from the splintering nest. Now, over the pastures</p>
<p class="v">of bananas, the island lifted its horns. Sunrise</p>
<p class="vsb">trickled down its valleys, blood splashed on the cedars,</p>
<p class="v">and the grove flooded with the light of sacrifice.</p>
<p class="v">A gommier was cracking. Its leaves an enormous</p>
<p class="vsb">tarpaulin with the ridgepole gone. The creaking sound</p>
<p class="v">made the fishermen leap back as the angling mast</p>
<p class="v">leant slowly towards the troughs of ferns; then the ground</p>
<p class="v">shuddered under the feet in waves, then the waves passed.</p>
<p class="vh"><span class="epub-sc">II</span></p>
<p class="v">Achille looked up at the hole the laurel had left.</p>
<p class="v">He saw the hole silently healing with the foam</p>
<p class="vsb">of a cloud like a breaker. Then he saw the swift</p>
<p class="v">crossing the cloud-surf, a small thing, far from its home,</p>
<p class="v">confused by the waves of blue hills. A thorn vine gripped</p>
<p class="vsb">his heel. He tugged it free. Around him, other ships</p>
<p class="v">were shaping from the saw. With his cutlass he made</p>
<p class="v">a swift sign of the cross, his thumb touching his lips</p>
<p class="vsb">while the height rang with axes. He swayed back the blade,</p>
<p class="v">and hacked the limbs from the dead god, knot after knot,</p>
<p class="v">wrenching the severed veins from the trunk as he prayed:</p>
<p class="vsb">“Tree! You can be a canoe! Or else you cannot!”</p>
<p class="v">The bearded elders endured the decimation</p>
<p class="v">of their tribe without uttering a syllable</p>
<p class="vsb">of that language they had uttered as one nation,</p>
<p class="v">the speech taught their saplings: from the towering babble</p>
<p class="v">of the cedar to green vowels of <span class="epub-i">bois-campêche.</span></p>
<p class="vsb">The <span class="epub-i">bois-flot</span> held its tongue with the <span class="epub-i">laurier-cannelle,</span></p>
<p class="v">the red-skinned logwood endured the thorns in its flesh,</p>
<p class="v">while the Aruacs’ patois crackled in the smell</p>
<p class="vsb">of a resinous bonfire that turned the leaves brown</p>
<p class="v">with curling tongues, then ash, and their language was lost.</p>
<p class="v">Like barbarians striding columns they have brought down,</p>
<p class="vsb">the fishermen shouted. The gods were down at last.</p>
<p class="v">Like pygmies they hacked the trunks of wrinkled giants</p>
<p class="v">for paddles and oars. They were working with the same</p>
<p class="vsb">concentration as an army of fire-ants.</p>
<p class="v">But vexed by the smoke for defaming their forest,</p>
<p class="v">blow-darts of mosquitoes kept needling Achille’s trunk.</p>
<p class="vsb">He frotted white rum on both forearms that, at least,</p>
<p class="v">those that he flattened to asterisks would die drunk.</p>
<p class="v">They went for his eyes. They circled them with attacks</p>
<p class="vsb">that made him weep blindly. Then the host retreated</p>
<p class="v">to high bamboo like the archers of Aruacs</p>
<p class="v">running from the muskets of cracking logs, routed</p>
<p class="vsb">by the fire’s banner and the remorseless axe</p>
<p class="v">hacking the branches. The men bound the big logs first</p>
<p class="v">with new hemp and, like ants, trundled them to a cliff</p>
<p class="vsb">to plunge through tall nettles. The logs gathered that thirst</p>
<p class="v">for the sea which their own vined bodies were born with.</p>
<p class="v">Now the trunks in eagerness to become canoes</p>
<p class="vsb">ploughed into breakers of bushes, making raw holes</p>
<p class="v">of boulders, feeling not death inside them, but use—</p>
<p class="v">to roof the sea, to be hulls. Then, on the beach, coals</p>
<p class="vsb">were set in their hollows that were chipped with an adze.</p>
<p class="v">A flat-bed truck had carried their rope-bound bodies.</p>
<p class="v">The charcoals, smouldering, cored the dugouts for days</p>
<p class="vsb">till heat widened the wood enough for ribbed gunwales.</p>
<p class="v">Under his tapping chisel Achille felt their hollows</p>
<p class="v">exhaling to touch the sea, lunging towards the haze</p>
<p class="vsb">of bird-printed islets, the beaks of their parted bows.</p>
<p class="v">Then everything fit. The pirogues crouched on the sand</p>
<p class="v">like hounds with sprigs in their teeth. The priest</p>
<p class="vsb">sprinkled them with a bell, then he made the swift’s sign.</p>
<p class="v">When he smiled at Achille’s canoe, <span class="epub-i">In God We Troust,</span></p>
<p class="v">Achille said: “Leave it! Is God’ spelling and mine.”</p>
<p class="vsb">After Mass one sunrise the canoes entered the troughs</p>
<p class="v">of the surpliced shallows, and their nodding prows</p>
<p class="v">agreed with the waves to forget their lives as trees;</p>
<p class="v">one would serve Hector and another, Achilles.</p>
<p class="vh"><span class="epub-sc">III</span></p>
<p class="v">Achille peed in the dark, then bolted the half-door shut.</p>
<p class="v">It was rusted from sea-blast. He hoisted the fishpot</p>
<p class="vsb">with the crab of one hand; in the hole under the hut</p>
<p class="v">he hid the cinder-block step. As he neared the depot,</p>
<p class="v">the dawn breeze salted him coming up the grey street</p>
<p class="vsb">past sleep-tight houses, under the sodium bars</p>
<p class="v">of street-lamps, to the dry asphalt scraped by his feet;</p>
<p class="v">he counted the small blue sparks of separate stars.</p>
<p class="vsb">Banana fronds nodded to the undulating</p>
<p class="v">anger of roosters, their cries screeching like red chalk</p>
<p class="v">drawing hills on a board. Like his teacher, waiting,</p>
<p class="vsb">the surf kept chafing at his deliberate walk.</p>
<p class="v">By the time they met at the wall of the concrete shed</p>
<p class="v">the morning star had stepped back, hating the odour</p>
<p class="vsb">of nets and fish-guts; the light was hard overhead</p>
<p class="v">and there was a horizon. He put the net by the door</p>
<p class="v">of the depot, then washed his hands in its basin.</p>
<p class="vsb">The surf did not raise its voice, even the ribbed hounds</p>
<p class="v">around the canoes were quiet; a flask of l’absinthe</p>
<p class="v">was passed by the fishermen, who made smacking sounds</p>
<p class="vsb">and shook at the bitter bark from which it was brewed.</p>
<p class="v">This was the light that Achille was happiest in.</p>
<p class="v">When, before their hands gripped the gunwales, they stood</p>
<p class="v">for the sea-width to enter them, feeling their day begin.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?2f4dc468